export default function gtagReportOrder() {
    if (window.gtag) {
        window.gtag('event', 'conversion', {
            send_to: 'AW-1021485745/C3arCO_T89UBELHFiucD'
        });
    }
}
